// ======================================================================
// File Name       : PasswordResetCompleteContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Path from '../../constants/PathConstants';
import { setGTMConfig, handleChangePageTitle } from '../../utils/PageUtils';

class PasswordResetCompleteContainer extends React.Component {

  componentWillMount() {
    setGTMConfig();
    // Step8.0.3 START
    handleChangePageTitle();
    this.unlisten = this.props.history.listen(() => handleChangePageTitle());
    // Step8.0.3 END
  }

  // Step8.0.3 START
  componentWillUnmount() {
    this.unlisten();
  }
  // Step8.0.3 END

  render() {
    return <>
      <Col className="container elastic">
        <Col className="margin-top-20 max-width-650">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
            }}
            className='form-horizontal'>
            <Col sm={12}>
              <h1>
                <strong>パスワードの再設定が完了しました</strong>
              </h1>
            </Col>
            <Col className="form-label margin-top-30" sm={12}>
              <p className="margin-top-10">管理ユーザー画面ログインのためのパスワードの再設定が完了しました。</p>
              <p className="margin-top-10">新しいパスワードでログインしてください。</p>
            </Col>
            <Col sm={12} className="margin-top-30">
              <Button type="submit" className="btn-96" onClick={() => { this.props.history.push(Path.LOGIN) }}>
                ログイン画面へ
              </Button>
            </Col>
            <input type="submit" hidden />
          </Form>
        </Col>
      </Col>
    </>;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { logined, authedUser } = state.authed;
  const { message } = state;
  return {
    authedUser,
    logined,
    superUser: state.superUser,
    message,
  };
};
export default connect(mapStateToProps)(PasswordResetCompleteContainer);
